import { render, staticRenderFns } from "./AdminPage.vue?vue&type=template&id=1d68077c&"
import script from "./AdminPage.vue?vue&type=script&lang=js&"
export * from "./AdminPage.vue?vue&type=script&lang=js&"
import style0 from "./AdminPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tachyon/facade-configurator/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1d68077c')) {
      api.createRecord('1d68077c', component.options)
    } else {
      api.reload('1d68077c', component.options)
    }
    module.hot.accept("./AdminPage.vue?vue&type=template&id=1d68077c&", function () {
      api.rerender('1d68077c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/UI/AdminPage.vue"
export default component.exports